

export const shareView = {
    sharedBy: 'Shared by '
  };
